import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArchiveComponent } from "./med-icon-archive.component";

@NgModule({
  declarations: [
    MedIconArchiveComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArchiveComponent,
  ],
})
export class MedIconArchiveModule { }
